<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Create New Fixture
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          v-model="serialNumber"
          outlined
          label="Serial Number"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="#f5f5f5" @click="onChangeClick()">Create</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    currentSerialNumber: String,
  },

  data() {
    return {
      serialNumber: '',
    };
  },

  methods: {
    onChangeClick() {
      this.$emit('close', { serialNumber: this.serialNumber });
      this.newSerialNumber = '';
    },

    onCancelClick() {
      this.$emit('close', { serialNumber: null });
      this.newSerialNumber = '';
    },
  },
};
</script>
